import { useQuery } from '@tanstack/react-query'

import { QueryKeys } from '@/app/_utils/react-query'

import { getPLPBasicMetas } from './get-plp-basic-metas'

import { usePLPFacetsContext } from '../facets-context/facets-context'
import { PLPBasicMetasProps, PLPPages } from '../types'

interface UseBasicMetasProps {
    basicMetas?: PLPBasicMetasProps
    isLoadingBasicMetas: boolean
}

export function useBasicMetas(): UseBasicMetasProps {
    const { page, slug } = usePLPFacetsContext()

    const {
        data: basicMetas,
        isRefetching,
        isLoading,
    } = useQuery<PLPBasicMetasProps>({
        queryKey: QueryKeys.PLP.BasicMeta(page, slug),
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        queryFn: () => getPLPBasicMetas(page, slug!),
        enabled: page !== PLPPages.Search && !!page && !!slug,
        staleTime: Infinity,
        refetchOnMount: false,
    })

    if (page === PLPPages.Search) return { basicMetas: undefined, isLoadingBasicMetas: false }

    return { basicMetas, isLoadingBasicMetas: isLoading || isRefetching }
}
